export const KEYWORDS_URL = 'keywords'
export const KEYWORDS_DETAIL_URL = 'keywords-detail'

export const KEYWORDS_TRANSACTION_PATH = `/project/:id/${KEYWORDS_URL}`
export const KEYWORDS_DETAIL_TRANSACTION_PATH = `/project/:id/${KEYWORDS_URL}/:keywordsId`
